<template>
  <div id="EnterpriseDeptDocOperations" v-uploader="dropFileHandler">
    <div style="float: left">
      <el-button v-if="addShow" size="small" type="primary" @click="addFolder"> <i class="el-icon-plus"></i> 新建文件夹 </el-button>
      <el-dropdown v-if="(isShowUploaderFile || isShowUploaderFolder) && uploadShow" class="btnBgColor" trigger="click" placement="bottom-start" @command="isFileOrFolder">
        <el-button size="small" type="primary" plain> <i class="el-icon-upload2"></i> 上传 </el-button>
        <el-dropdown-menu slot="dropdown" style="width: 94px">
          <el-dropdown-item v-if="isShowUploaderFile" command="file" style="text-align: center !important"> 文件 </el-dropdown-item>
          <el-dropdown-item v-if="isShowUploaderFolder" command="folder" style="text-align: center !important"> 文件夹 </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button v-if="moveShow" size="small" type="primary" plain @click="moveFile('移动到')"> <i class="el-icon-rank"></i> 移动到 </el-button>
      <el-button v-if="copyShow" size="small" type="primary" plain @click="copyFile('复制到')"> <i class="el-icon-document-copy"></i> 复制到 </el-button>
      <el-button v-if="downShow" size="small" type="primary" plain @click="batchDownload"> <i class="el-icon-download"></i> 下载 </el-button>
      <el-button v-if="shareShow" size="small" type="primary" plain @click="batchShare"> <i class="el-icon-share"></i> 分享 </el-button>
      <el-button v-if="deleShow" size="small" type="danger" plain @click="batchDel"> <i class="el-icon-delete"></i> 删除 </el-button>
    </div>
    <div class="search" style="margin-left: auto">
      <el-input
        v-model.trim="searchValue"
        type="text"
        style="height: 100%; cursor: pointer"
        size="small"
        :placeholder="searchTiTle"
        :suffix-icon="!searchValue ? 'el-icon-search' : ''"
        :clearable="Boolean(searchValue)"
        maxlength="20"
      >
      </el-input>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service";
import { downloadFile, downloadUrlNoPermissiontoken } from "@/CommonDP/utils";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { uploader } from "@/CommonDP/utils/IUploader/dp";
import { UserIdentity, DocMoveAndCopyDialog } from "@/CommonDP/pages/mainMg/doc/common.js";
export default {
  directives: { uploader: uploader.directive() },
  props: {
    folderId: {
      type: String,
      default: ""
    },
    folderPermissions: {
      type: String,
      default: UserIdentity.ISOUT
    }
  },
  data() {
    return {
      searchValue: "",
      addAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_ADD),
      moveAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_MOVE),
      copyAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_COPY),
      downAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_DOWNLOAD),
      shareAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_SHARE),
      deleAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_DELETE),
      uploadAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_UPLOAD),
      addAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_ADD),
      moveAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_MOVE),
      copyAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_COPY),
      downAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_DOWNLOAD),
      shareAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_SHARE),
      deleAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_DELETE),
      uploadAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_UPLOAD),
      val: "",
      addShow: false,
      uploadShow: false,
      moveShow: false,
      copyShow: false,
      downShow: false,
      shareShow: false,
      deleShow: false
    };
  },
  computed: {
    ...mapState({
      currentNode: (state) => state.perFile.currentTreeNodeDan,
      selectArr: (state) => state.XtDesign.selectArr, // 勾选的文件
      perFileMoveAndCopy: (state) => state.perFile.moveAndCopy,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    uploaderOpts() {
      const data = this.currentNode;
      const folderId = data.folderId;
      const params = {
        prjId: "EnterpriseDeptDoc",
        folderId,
        versionId: ""
      };
      return { params, multiple: true, showPanel: true, once: false };
    },
    isShowUploaderFile() {
      let data = this.currentNode;
      data = data || {};
      return data.fileNew ? data.fileNew === 1 : false;
    },
    isShowUploaderFolder() {
      let data = this.currentNode;
      data = data || {};
      return data.folderNew ? data.folderNew === 1 : false;
    },
    searchTiTle() {
      let data = this.currentNode;
      data = data || {};
      const { folderName } = data;
      return folderName ? `搜索"${folderName}"` : "";
    }
  },
  watch: {
    searchValue(newValue, oldValue) {
      clearTimeout(this.timeID);
      if (newValue) {
        this.timeID = setTimeout(() => {
          console.log("开始搜索啦");
          this.search();
        }, 500);
      } else {
        this.refresh();
      }
    }
  },
  created() {
    this.queryManager();
  },
  methods: {
    async queryManager() {
      if (this.folderPermissions === UserIdentity.ISADIM) {
        // 如果你是管理员 就默认有全部的权限
        this.addShow = true;
        this.uploadShow = true;
        this.moveShow = true;
        this.copyShow = true;
        this.downShow = true;
        this.shareShow = true;
        this.deleShow = true;
      } else if (this.folderPermissions === UserIdentity.ISDEPT) {
        this.addShow = this.addAllEnterpriseDeptDoc || this.addAffiliationEnterpriseDeptDoc;
        this.uploadShow = this.uploadAllEnterpriseDeptDoc || this.uploadAffiliationEnterpriseDeptDoc;
        this.moveShow = this.moveAllEnterpriseDeptDoc || this.moveAffiliationEnterpriseDeptDoc;
        this.copyShow = this.copyAllEnterpriseDeptDoc || this.copyAffiliationEnterpriseDeptDoc;
        this.downShow = this.downAllEnterpriseDeptDoc || this.downAffiliationEnterpriseDeptDoc;
        this.shareShow = this.shareAllEnterpriseDeptDoc || this.shareAllEnterpriseDeptDoc;
        this.deleShow = this.deleAllEnterpriseDeptDoc || this.deleAffiliationEnterpriseDeptDoc;
      } else {
        this.addShow = this.addAllEnterpriseDeptDoc;
        this.uploadShow = this.uploadAllEnterpriseDeptDoc;
        this.moveShow = this.moveAllEnterpriseDeptDoc;
        this.copyShow = this.copyAllEnterpriseDeptDoc;
        this.downShow = this.downAllEnterpriseDeptDoc;
        this.shareShow = this.shareAllEnterpriseDeptDoc;
        this.deleShow = this.deleAllEnterpriseDeptDoc;
      }
    },
    // 移动到
    async moveFile(val) {
      if (this.selectArr.length === 0) {
        this.$message.warning("请选择至少一条数据");
      } else {
        await DocMoveAndCopyDialog({ type: "move", folderId: this.folderId, selectArr: this.selectArr });
        this.$emit("pf");
      }
    },
    // 复制到
    async copyFile(val) {
      if (this.selectArr.length === 0) {
        this.$message.warning("请选择至少一条数据");
      } else {
        await DocMoveAndCopyDialog({ type: "copy", folderId: this.folderId, selectArr: this.selectArr });
        this.$emit("pf");
      }
    },

    // 新建文件夹
    addFolder() {
      const { folderId } = this.currentNode;
      this.$prompt("", "新建文件夹", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入文件夹名称",
        inputPattern: /^\S*$/,
        inputErrorMessage: "文件夹名称不能包含空格",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        inputValidator: (value) => {
          if (!value) {
            return "文件夹名称不能为空";
          }
          if (value.length > 80) {
            return "文件夹名称不能大于80个字符";
          }
          var regExp = new RegExp('[\\\\|/:*<>?"]');
          if (regExp.test(value)) {
            return '文件夹名称不能包含以下字符:\\ / : * " ? < > |';
          }
          this.val = value;
        },
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            // 点击确定 要做的事情
            this.$store.dispatch("perFileUpdateMessageObj", {
              isShow: true,
              message: "新建中..."
            });
            const enterpriseId = this.enterpriseId;
            const parentId = folderId;
            const folderName = this.val.replace(/\s*/g, "");
            const data = { parentId, folderName, enterpriseId };
            try {
              const result = await secondaryMenuService.enterpriseDeptAddFolder(data);
              if (result.result === "0") {
                await this.$store.dispatch("perFileUpdateNodeList");
                this.$store.dispatch("perFileUpdateMessageObj", {
                  isShow: false
                });
                this.$message.success("新建成功"); /*  */
                this.$emit("pf");
                done();
              }
            } catch (e) {
              this.$store.dispatch("perFileUpdateMessageObj", { isShow: true });
            }
          } else {
            done();
          }
        }
      }).catch(() => {});
    },
    // 分享
    batchShare() {
      const batchArr = this.selectArr;
      if (batchArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      this.$store.dispatch("XtDesignIsShowShare");
    },
    async dropFileHandler(files, cb) {
      const opts = this.uploaderOpts;
      if (this.uploadShow) {
        const list = files.filter((file) => (file.relativePath === file.name ? this.isShowUploaderFile : this.isShowUploaderFolder));
        if (!list.length) return;
        await cb(list, opts);
        this.refresh();
      }
    },
    // 上传文件 文件夹
    async isFileOrFolder(type) {
      const opts = this.uploaderOpts;
      await uploader.open({ ...opts, isDirectory: type !== "file" });
      this.refresh();
    },
    // 删除功能
    async batchDel() {
      const batchArr = this.selectArr;
      if (batchArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      const newData = this.selectArr.map((item) => item.folderId);
      try {
        this.$confirm("确定删除吗?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(async () => {
            this.$store.dispatch("perFileUpdateMessageObj", {
              isShow: true,
              message: "删除中..."
            });
            const result = await secondaryMenuService.queryDeleteNoPermissionFile(newData);
            if (result.result === "0") {
              await this.$store.dispatch("perFileDelListRow", newData);
              this.$store.dispatch("perFileUpdateMessageObj", {
                isShow: false,
                message: ""
              });
              this.$message({ type: "success", message: "删除成功" });
              this.$emit("pf");
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: false,
          message: ""
        });
      }
    },
    // 下载1
    batchDownload() {
      const batchArr = this.selectArr;
      if (batchArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      const isFolder = batchArr.some((item) => item.isFolder === 1);
      if (isFolder) {
        return this.$message({
          type: "warning",
          message: "文件夹不支持批量下载"
        });
      } else if (batchArr.length > 10) {
        return this.$message.warning("一次批量下载最多选择10个文件");
      } else {
        const prjId = "EnterpriseDeptDoc";
        const urls = batchArr.map((item) => {
          return downloadUrlNoPermissiontoken(prjId, item.folderId, item.fileVersion);
        });
        for (let i = 0; i < urls.length; i++) {
          downloadFile(urls[i]);
        }
      }
    },
    refresh() {
      this.$emit("pf4", "");
      this.$store.dispatch("perShareCol", false);
      let data = this.currentNode;
      data = data || {};
      const { folderId } = data;
      if (folderId) {
        this.$store.dispatch("perFileUploadSucceedCB", folderId);
      }
    },
    search() {
      const keyWord = this.searchValue.replace(/\s*/g, "");
      const { folderId } = this.currentNode;
      const prjId = "EnterpriseDeptDoc";
      const enterpriseId = this.enterpriseId;
      const searchObj = { prjId, folderId, keyWord, enterpriseId };
      this.$emit("pf4", searchObj);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#EnterpriseDeptDocOperations {
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: var(--middle-space) var(--big-space);
  box-sizing: border-box;

  .btnBgColor {
    margin: 0 var(--small-space);
  }
}
</style>
